import React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

export default createSvgIcon(
  [<circle cx="12" cy="6" r="1.5" fill="currentColor" key="0" />,<circle cx="12" cy="12" r="1.5" fill="currentColor" key="1" />,<circle cx="12" cy="18" r="1.5" fill="currentColor" key="2" />,]
, 'ActionMorex');
